<template>
<div class="AsideMenuContainer">
  <div class="collapseOpenOrClose" :style="{ width : !menuCollapse ? '100px' : '24px' }">
    <i @click="openOrClose"><img src="../../assets/img/openOrClose.png" alt=""></i>
    <span v-show="!menuCollapse">折叠导航</span>
  </div>
  <div class="systemTitle">
    <div class="logo">
      <!-- <i v-show="!menuCollapse" class="imgBox"><img src="../../assets/img/logo.png" alt=""></i> -->
      <i v-show="!menuCollapse" class="imgBox"><img :src="`${baseUrlAddr}/front/picUploadAndDownload/download2?fileName=${picName}`" alt="" class="img-item"></i>
      <h2 v-show="!menuCollapse" class="title">{{systemName}}</h2>
      <i v-show="menuCollapse" class="imgBox"><img :src="`${baseUrlAddr}/front/picUploadAndDownload/download2?fileName=${picName}`" alt="" class="img-item"></i>
    </div>
  </div>
  <div class="menuTree">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu :default-active="defaultMenu" class="leftAsideMenu" background-color="transparent" text-color="rgba(255,255,255,1)" active-text-color="#1089FF" menu-trigger="click" @select="menuSelected" unique-opened :collapse="menuCollapse" collapse-transition router @open="handleOpen" @close="handleClose">
        <NavMenu :navMenus="menuList" level='1'></NavMenu>
      </el-menu>
    </el-scrollbar>
  </div>
</div>
</template>

<script>
import bus from '@/bus/bus';
import NavMenu from "@/components/layout/NavMenu";
export default {
  components: {
    NavMenu
  },
  data() {
    return {
      defaultMenu: '',
      menuList: [],
      selectMenu: '',
      flagNav: false,
      is_click: false,
      picName: 'xtlogo.png'
    };
  },
  watch: {
    $route(nV, oV) {
      // console.log(nV);
      this.defaultMenu = nV.path;
    },
    menuCollapse(nV) {
      setTimeout(()=>{
        // this.menuList=[]
        this.routeInit();
        this.$store.commit('changeMenuCollapse', nV)
        this.routeInit();
      },440)
    }
  },
  created() {
    this.defaultMenu = this.$route.path;
    this.getParamsSet()
    this.routeInit();
  },
  computed: {
    menuCollapse() {
      return this.$store.state.menuIsCollapse
    },
    systemName() {
      document.title = this.$store.state.systemName
      return this.$store.state.systemName
    }
  },
  mounted() {
    bus.$on('changeSysname', e => {
      this.$store.dispatch('setSystemName', e)
      document.title = e
    })
  },
  methods: {
    routeInit() {
      // console.log(this.$route.name);
      this.request
        .get("/front/system/module/query/tree")
        .then((res) => {
          //左侧菜单
          if (res.code == 200) {
            this.menuList = res.data
            let flag = true
            this.menuList.forEach((val) => {
              //菜单赋值
              if ('/' + this.$route.name == val.componentUrl) {
                flag = false
                // console.log(val);
                this.$store.dispatch('setMenuName', val)
              }
              if (val.children != null) {
                val.children.forEach(item => {
                  if ('/' + this.$route.name == item.componentUrl) {
                    flag = false
                    // console.log(1,val);
                    this.$store.dispatch('setMenuName', val)
                  }
                  if (item.children != null) {
                    item.children.forEach(value => {
                      if ('/' + this.$route.name == value.componentUrl) {
                        flag = false
                        // console.log(2,val);
                        this.$store.dispatch('setMenuNameNew', item)
                        this.$store.dispatch('setMenuName', val)
                      }
                    })
                  }
                })
              }
            });
            if (flag) {
              // console.log(555);
              if (res.data[0].children[0].children != null) {
                this.$router.push(res.data[0].children[0].children[0].componentUrl)
              } else if (res.data[0].children != null) {
                this.$router.push(res.data[0].children[0].componentUrl)
              } else {
                this.$router.push(res.data[0].componentUrl)
              }
            }
          } else if (res.code == 500) {
            this.msg.warn(res.msg)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    menuSelected(key, keyPath) {
      // console.log(key, keyPath);
      this.selectMenu = key
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    getParamsSet() {
      this.request.get('/front/system/config/query').then(res => {
        // console.log(res);
        if (res.code == 200) {
          // let nameItem = res.data.filter(item => item.code == 'SYS_NAME')
          let nameItem = { value: '' }
          let logoItem = { value: 'xtlogo.png' }
          res.data.forEach(item => {
            if (item.code == 'SYS_NAME') nameItem = item
            if (item.code == 'SYS_LOGO') logoItem = item
          })
          this.picName = logoItem.value
          // console.log(`nameItem`, nameItem)
          if (nameItem.value) {
            this.$store.dispatch('setSystemName', nameItem.value)
          } else {
            this.$store.dispatch('setSystemName', '智慧星图消防物联网管理平台')
          }
        }
      })
    },
    openOrClose() {
      if(this.is_click){
        return false;
      }
      // console.log('我是要执行的部分 每次点击执行一次');
      this.flagNav = !this.flagNav
      this.$store.commit('changeMenuCollapse', this.flagNav)
      this.is_click=true;
      setTimeout(()=>{
        this.is_click=false;

      },440)
    },
    getInfo() {
      let flag = true
      // console.log(this.menuList);
      this.menuList.forEach((val) => {
        //菜单赋值
        if ('/' + this.$route.name == val.componentUrl) {
          flag = false
          // console.log(val);
          this.$store.dispatch('setMenuName', val)
        }
        if (val.children != null) {
          val.children.forEach(item => {
            if ('/' + this.$route.name == item.componentUrl) {
              flag = false
              // console.log(1,val);
              this.$store.dispatch('setMenuName', val)
            }
            if (item.children != null) {
              item.children.forEach(value => {
                if ('/' + this.$route.name == value.componentUrl) {
                  flag = false
                  // console.log(2,val);
                  this.$store.dispatch('setMenuNameNew', item)
                  this.$store.dispatch('setMenuName', val)
                }
              })
            }
          })
        }
      })
    },
    fiterChildren(param) {
      let flag = true
      if (param.children != null) {
        param.children.forEach(value => {
          if ('/' + this.$route.name == value.componentUrl) {
            flag = false
            this.sendMess = true
          }
          if (flag) {
            if (value.children != null) {
              this.fiterChildren(value.children)
            }
          }
        })
      } else {
        return
      }
      if (flag) {
        this.sendMess = false
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.AsideMenuContainer {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding: 160px 0 94px;

  .systemTitle {
    // border: 1px solid red;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 158px;
    border-bottom: 1px solid #1e347d;

    h2 {
      font-size: 24px;
      text-align: center;
      overflow: hidden;
      color: #1089FF;
      letter-spacing: 2px;
      background: linear-gradient(180deg, #10BBFF 0%, #1089FF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: PangMenZhengDao;
      line-height: 28px;
      font-weight: 400;
      padding: 0 14px;
    }

    i {
      width: 51px;
      // height: 62px;
      display: block;
      margin: 15px auto 10px;
    }
  }

  .collapseOpenOrClose {
    position: absolute;
    left: 26px;
    bottom: 50px;
    z-index: 9999;

    i {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: #23262A;
      border-radius: 50%;
      margin-right: 16px;
      cursor: pointer;
      vertical-align: bottom;

      img {
        width: 24px;
        height: 24px;
      }
    }

    span {
      line-height: 24px;
      font-size: 14px;
      font-weight: 500;
      color: #FFFFFF;
    }
  }

  .menuTree {
    height: 100%;

    .leftAsideMenu {
      padding: 0 6px;
      border-right: none;
    }
  }
}
</style><style lang="scss">
.AsideMenuContainer {
  .menuTree {
    .leftAsideMenu {
      &.el-menu--collapse {
        width: 60px;
      }
    }

    .el-scrollbar {
      .is-horizontal {
        display: none;
      }
    }
  }
  .el-submenu.subLevel1 .el-menu-item:hover {
    background-color: rgba(0,0,0,.3)!important;
  }
  .el-submenu__title:hover {
    background-color: rgba(0,0,0,.3)!important;
    // background-color: #3b4875!important;
  }
}
.el-menu--vertical {
  background: #152353;
//   background: linear-gradient(to bottom, #192F78, #111835);
  .el-menu-item:hover {
    background-color: rgba(0,0,0,.3)!important;
  }
  .el-submenu__title:hover {
    background-color: rgba(0,0,0,.3)!important;
    // background-color: #3b4875!important;
  }
}
</style>
